module.exports = __webpack_public_path__ + "static/media/flowers.259ff042.jpg";